import React, { Component } from "react";
import FormContainer from "../../package-form/FormContainer";

import './Newsletter.css';

class Newsletter extends Component {
  render() {
    return (
      <div className="newsletterOverlay">
        <div className="newsletterContent">
          <div className="host" />
          <div className="msgContainer">
            <div className="close" onClick={this.props.handleNewsletterClose}>X</div>
            <div className="msgInnerContainer">
              <FormContainer
                handleShowNewsletter={this.props.handleShowNewsletter}
                handleNewsletterSubmit={this.props.handleNewsletterSubmit}
              />
              <div className="link" onClick={this.props.handleWatchVideoClick}>
                Don’t want to sign up? Watch a video.
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Newsletter;


// WEBPACK FOOTER //
// ./src/package-reward-ads-overlay/components/Newsletter.js